<template>
  <div>
    <com-package-order-search typeOfView="partner" @search="handleSearch"></com-package-order-search>
    <div class="mb-15px flex justify-end">
      <el-button type="primary" @click="handleExport" :disabled="isExporting" :loading="isExporting">导出</el-button>
    </div>
    <com-package-order-list
      typeOfView="partner"
      :default-params="defaultParams"
      ref="table"
    ></com-package-order-list>
  </div>
</template>

<script>
import { partnerPackageOrderExport } from '@/api/partners'
import { downloadFile } from '@/utils/download'

export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: ''
    }
  },
  watch: {
    code: {
      handler(val) {
        if (val) {
          this.defaultParams.refPartner = val
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      defaultParams: {},
      activeName: '0',
      exportQuery: {},
      isExporting: false,
      searchColumn: [
        {
          label: '网点名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '绑定时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    handleClick() {
      if (this.activeName === '1') {
        this.defaultParams.areaPartnerCode = this.code
        delete this.defaultParams.partnerCode
        this.$refs.table.init()
        return
      }

      this.defaultParams.partnerCode = this.code
      delete this.defaultParams.areaPartnerCode
      this.$refs.table.init()
    },
    handleSearch(val) {
      this.exportQuery = { ...val }
      this.$refs.table.search(val)
    },
    handleExport() {
      if (!this.code) {
        this.$message.error('合伙人编码不能为空')
        return
      }

      if (this.isExporting) {
        this.$message.warning('正在导出中，请勿重复点击')
        return
      }

      this.isExporting = true
      this.$message.info('请稍等,正在导出...')

      const params = {
        refPartner: this.code,
        ...this.exportQuery
      }

      partnerPackageOrderExport(params)
        .then((blob) => {
          downloadFile(blob, `套餐卡订单_${new Date().getTime()}.xlsx`)
          this.$message.success('导出成功')
        })
        .catch((error) => {
          console.error('导出失败:', error)
        })
        .finally(() => {
          this.isExporting = false
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
